export const onboardBackground = (admin, mobile) => mobile
  ? { background: null }
  : admin
    ? { background: 4, position: '-485px 0px', size: '1213px 1163px' }
    : { background: 5 }

export const signUpBackground = (mobile, admin, password, free) => mobile
  ? (password || admin)
    ? { background: null }
    : { background: 1, position: '-247px -172px', size: '2072px 2034px' }
  : password
    ? admin
      ? { background: 1, position: '-1146px -512px', size: '2072px 2034px' }
      : { background: 5, position: '-750px 0' }
    : free
      ? { background: 2 }
      : { background: 1, position: '-406px -512px', size: '2072px 2034px' }

export const subscriptionBackground = (mobile, payment, partnerForm) => mobile
  ? payment
    ? { background: 7, position: '-839px -252px', size: '1298px 1541px' }
    : partnerForm
      ? { background: 7, position: '-299px -142px', size: '1298px 1541px' }
      : { background: null }
  : payment
    ? { background: 1, position: '-1146px -512px', size: '2072px 2034px' }
    : { background: null }
